import { ReactElement } from "react";
import { ValidGlobalSearchItemPersistedModel } from "../../Persistence/validation";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { SearchListItem } from "client/Features/Search/SearchListItem";
import { generateTrackingId } from "client/Misc/utils";
import { ContactListItem } from "client/Features/Layout/TitleBar/GlobalSearch/Items/ContactListItem";
import { useContactNavigationHandler } from "client/Features/Layout/TitleBar/GlobalSearch/Navigation/useContactNavigationHandler";
import { ContactSource } from "client/Api/Email/contacts";

export type ContactItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.Contact>;
	navigationIndex: number;
	onRemove: () => void;
	onOpenContactDetails: (id: string, contactSource: ContactSource) => void;
};

export const ContactItemView = (props: ContactItemViewProps): ReactElement => {
	const {
		item,
		navigationIndex,
		onRemove,
		onOpenContactDetails
	} = props;

	const {
		id,
		contactSource,
		firstName,
		middleName,
		lastName,
		displayName,
		jobTitle,
		department,
		company,
		emailAddress,
		phoneNumber,
		photoUrl
	} = item.contact;

	const executeHandler: () => void = useContactNavigationHandler({
		id,
		contactSource,
		recentlyOpenedItem: item,
		onOpenContactDetails: onOpenContactDetails
	});

	return (
		<SearchListItem
			onExecute={executeHandler}
			trackingId={generateTrackingId("contact-item", `|${contactSource}/${id}`)}
		>
			<ContactListItem
				id={id}
				contactSource={contactSource}
				firstName={firstName}
				middleName={middleName}
				lastName={lastName}
				displayName={displayName}
				jobTitle={jobTitle}
				department={department}
				company={company}
				emailAddress={emailAddress}
				phoneNumber={phoneNumber}
				photoUrl={photoUrl}
				onRemove={onRemove}
				itemIndex={navigationIndex}
				tabIndex={-1}
				onExecute={executeHandler}
			/>
		</SearchListItem>
	);
};
ContactItemView.displayName = "ContactItemView";